import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const ProjectSingle = () => {

  // Get Project details passed via router state
  const location = useLocation();
  const project = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={project.title} page={"Project Single"} />

      <section className='project-single page-single'>

        <div className='project-info page-info'>

          {/* Project Image */}
          <div className='image'>
            <img src={project.image} alt={project.title} />
          </div>

          <div className='content'>

            {/* Project Title */}
            <h3 className='main-heading'>{project.title}</h3>

            {/* Project Description */}
            {project.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Project Image Gallery */}
            <Lightbox images={project.gallery} />

            {/* Project Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Challenges:</h3>
              <p>Key challenges encountered while delivering laundry and dry cleaning services for the {project.title} project:</p>

              {/* List of Project Challenges */}
              <ul>
                {project.challenges.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Project Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Solutions:</h3>
              <p>We addressed these laundry and dry cleaning challenges with effective, fabric-specific solutions:</p>

              {/*Project Solutions List */}
              <ul>
                {project.solutions.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Results:</h3>
              <p>The service delivered spotless results, timely turnaround, and high levels of customer satisfaction:</p>

              {/* Project Results */}
              <ul>
                {project.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Project details */}
        <PageSidebar
          heading={'Project'}
          details={project.details}
        />

      </section>

    </> 
  );
}

export default ProjectSingle;